import { render, staticRenderFns } from "./attendance-check.vue?vue&type=template&id=6fd60abb&scoped=true&"
import script from "./attendance-check.vue?vue&type=script&lang=js&"
export * from "./attendance-check.vue?vue&type=script&lang=js&"
import style0 from "./attendance-check.vue?vue&type=style&index=0&id=6fd60abb&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd60abb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavCheck: require('/home/smiley/3df/components/Nav/NavCheck/NavCheck.vue').default,AttendanceForm: require('/home/smiley/3df/components/Attendance/AttendanceForm/AttendanceForm.vue').default,AttendanceClient: require('/home/smiley/3df/components/Attendance/AttendanceClient/AttendanceClient.vue').default})
